import React, { useCallback } from 'react';
import DefaultMsgPage from 'components/DefaultMsgPage';

const ResentedEmail: React.FC = () => {
  const handleRedirect = useCallback(async () => {
    window.location.replace('/login');
  }, []);

  return <DefaultMsgPage traductionKey="generic_error_screen" image="brokenSuitcase" onPrimary={handleRedirect} />;
};

export default ResentedEmail;
